import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from "./jsx.js";
import { Footer } from "./Footer.js";
import { Header } from "./Header.js";
import { LoadingBar } from "./LoadingBar.js";
import { FetchTracker } from "./FetchTracker.js";
export function Page({ title, children, ...other }) {
    return (_jsx(StrictMode, { children: _jsxs(FetchTracker, { children: [_jsx(LoadingBar, {}), _jsxs("div", { "data-testid": "page", className: `py-8 lg:py-16 px-6 md:px-16 lg:px-24`, children: [_jsx(Header, { title: title, date: other.date, tags: other.tags }), _jsx("div", { className: `lg:pl-32 mt-12`, children: children }), _jsx(Footer, { ...other })] })] }) }));
}
